import { StateEnum } from "../../../Models/Bases/StateEnum";
import { BaseService } from "../../Bases/BaseService";
import { ValidationResponse } from "../../Bases/ValidationResponse";

export class UsuarioNaoConformidadeService extends BaseService {
    public selecionarValidos(usuarioNaoConformidades: any) {
        return usuarioNaoConformidades?.filter((e: any) => e.state != StateEnum.Deleted) ?? [];
    }

    public salvar(usuarioNaoConformidade: any, usuarioNaoConformidades: any) {
        if (!this.numberIsFilled(usuarioNaoConformidade.nao_conformidade_id) ) {
            return new ValidationResponse(null, 'Preencha o campo Não Conformidade!');
        }

        let validation = usuarioNaoConformidades?.filter(
            (e: any) =>
                usuarioNaoConformidade.id != e.id &&
                usuarioNaoConformidade.nao_conformidade_id == e.nao_conformidade_id &&
                e.state != StateEnum.Deleted);

        if (validation.length > 0) {
            return new ValidationResponse(null, 'Não Conformidade já inserida!');
        }

        let ids = usuarioNaoConformidades?.map((x: any) => x.id) ?? [];
        let min = Math.min.apply(null, ids);
        usuarioNaoConformidade.id = min > 0 ? -1 : min - 1;
        usuarioNaoConformidade.state = StateEnum.Inserted;
        usuarioNaoConformidades = usuarioNaoConformidades.concat(usuarioNaoConformidade);

        return new ValidationResponse(usuarioNaoConformidades);
    }

    public apagar(id: number, usuarioNaoConformidades: any) {
        if (id > 0) {
            usuarioNaoConformidades.forEach((e: any) => e.state = (e.id == id ? StateEnum.Deleted : e.state));
        }
        else {
            usuarioNaoConformidades = usuarioNaoConformidades?.filter((e: any) => e.id != id);
        }

        return new ValidationResponse(usuarioNaoConformidades);
    }
}